<template lang="pug">
.v-price-banner.price-banner(v-if="data" :id="data?.id")
	.price-banner__title(v-if="data.title" v-html="data.title")
	.price-banner__items(v-if="data.items")
		.price-banner__item(v-for="item in data.items")
			span.price-banner__item-value(v-if="item.value") {{item.value}}
			span.price-banner__item-text(v-if="item.text") {{item.text}}
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>